<div class="transfer_body">
    <div class="top_panel">
        <h3>Transfer Agreement</h3>
        <span (click)="close()" class="close">
          <img src="https://cdn.elitehw.com/images/cross.webp" />
        </span>
    </div>
    <div class="body_panel">
        <mat-tab-group (selectedTabChange)="onTabChange($event)">
            <mat-tab label="Update Agreement Holder">
              <form [formGroup]="userDetailForm">
                <div class="card_detail">
                  <ng-container *ngIf="userFormStep === 1">
                    <div class="card_panel full">
                      <label> Email </label>
                      <span>
                          <input
                          type="text"
                          placeholder="Email"
                          formControlName="emailAddress"
                          />
                          <mat-error *ngIf="userDetailForm.controls['emailAddress'].touched && userDetailForm.controls['emailAddress'].hasError('required')">
                            This is required field.
                          </mat-error>
                          <mat-error *ngIf="userDetailForm.controls['emailAddress'].touched && userDetailForm.controls['emailAddress'].hasError('pattern')">
                            Enter valid email.
                          </mat-error>
                      </span>
                      
                      
                    </div>
                    <button mat-flat-button class="next" (click)="getConsumerDetailByEmail()" [disabled]="isFetchingUserDetails">
                      Next
                      <mat-icon>chevron_right</mat-icon>
                    </button>
                  </ng-container>
                  <ng-container *ngIf="userFormStep === 2">
                    <div class="card_panel">
                      <label> First Name </label>
                      <span>
                          <input
                          type="text"
                          placeholder="First Name"
                          formControlName="firstName"
                          [readOnly]="customerDetails"
                          />
                          <mat-error *ngIf="userDetailForm.controls['firstName'].touched && userDetailForm.controls['firstName'].hasError('required')">
                            This is required field.
                          </mat-error>
                      </span>
                  </div>
                  <div class="card_panel">
                      <label> Last Name </label>
                      <span>
                          <input
                          type="text"
                          placeholder="Last Name"
                          formControlName="lastName"
                          [readOnly]="customerDetails"
                          />
                          <mat-error *ngIf="userDetailForm.controls['lastName'].touched && userDetailForm.controls['lastName'].hasError('required')">
                            This is required field.
                          </mat-error>
                      </span>
                  </div>
                  <div class="card_panel">
                      <label> Phone no </label>
                      <span>
                          <input
                          type="text"
                          placeholder="Phone no"
                          formControlName="phoneNumber"
                          mask="(000) 000-0000"
                          [readOnly]="customerDetails"
                          />
                          <mat-error *ngIf="userDetailForm.controls['phoneNumber'].touched && userDetailForm.controls['phoneNumber'].hasError('required')">
                            This is required field.
                          </mat-error>
                          <mat-error *ngIf="userDetailForm.controls['phoneNumber'].touched && userDetailForm.controls['phoneNumber'].hasError('pattern')">
                            Enter valid phone no.
                          </mat-error>
                      </span>
                  </div>
                  <div class="card_panel2">
                    <label>Moved Date</label>
                    <span>
                      <mat-form-field class="example-full-width" appearance="outline">
                        <mat-label>Moved Date</mat-label>
                        <input matInput [matDatepicker]="picker" formControlName="movedDate" [min]="minData" (click)="picker.open()" [readonly]="true" placeholder="Select date">
                        <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
                        <mat-datepicker #picker></mat-datepicker>

                        <mat-error *ngIf="userDetailForm.controls['movedDate'].touched && userDetailForm.controls['movedDate'].hasError('required')">
                          This is required field.
                        </mat-error>
                    </mat-form-field>
                    
                    </span>
                  </div>
                  <button mat-flat-button class="next" (click)="userFormStep = 1">
                    <mat-icon>chevron_left</mat-icon>
                    Back
                  </button>
                  </ng-container>
              </div>
              </form>
            </mat-tab>
            <mat-tab label="Update Covered Address"> 
              <form [formGroup]="coveredAddressForm">
                <div class="card_detail">
                  <div class="card_panel addres">
                      <label> Address </label>
                      <span>
                          <input
                          type="text"
                          placeholder="Address"
                          formControlName="streetAddress"
                          #billingLocation
                          />
                          <mat-error *ngIf="coveredAddressForm.controls['streetAddress'].touched && coveredAddressForm.controls['streetAddress'].hasError('required')">
                            This is required field.
                          </mat-error>
                      </span>
                  </div>
                  <div class="card_panel unit">
                      <label> Unit Number </label>
                      <span>
                          <input
                          type="text"
                          placeholder="Unit Number"
                          formControlName="unitNumber"
                          />
                          <mat-error *ngIf="coveredAddressForm.controls['unitNumber'].touched && coveredAddressForm.controls['unitNumber'].hasError('required')">
                            This is required field.
                          </mat-error>
                      </span>
                  </div>
                  <div class="cardflex">
                      <div class="card_panel">
                        <label>City </label>
                        <span>
                          <input
                            type="text"
                            placeholder="City"
                            formControlName="city"
                            readonly
                          />
                          <mat-error *ngIf="coveredAddressForm.controls['city'].touched && coveredAddressForm.controls['city'].hasError('required')">
                            This is required field.
                          </mat-error>
                        </span>
                      </div>
                      <div class="card_panel">
                        <label>State </label>
                        <span>
                          <input
                            type="text"
                            placeholder="State"
                            formControlName="state"
                            readonly
                          />
                          <mat-error *ngIf="coveredAddressForm.controls['state'].touched && coveredAddressForm.controls['state'].hasError('required')">
                            This is required field.
                          </mat-error>
                        </span>
                      </div>
                      <div class="card_panel">
                        <label> Zip </label>
                        <span>
                          <input
                            type="text"
                            placeholder="Zip"
                            formControlName="zip"
                            mask="00000" 
                            (keyup)="checkZipCode($event)"
                          />
                          <mat-error *ngIf="coveredAddressForm.controls['zip'].touched && coveredAddressForm.controls['zip'].hasError('required')">
                            This is required field.
                          </mat-error>
                          <mat-error *ngIf="coveredAddressForm.controls['zip'].hasError('notValid')">
                            Please enter valid zip.
                        </mat-error>
                        </span>
                      </div>
                  </div>
                  <div class="card_panel2 full_width">
                    <label>Moved Date</label>
                    <span>
                      <mat-form-field class="example-full-width" appearance="outline">
                        <!-- <mat-label>Closing Date</mat-label> -->
                        <input matInput [matDatepicker]="picker1" formControlName="movedDate" [min]="minData" (click)="picker1.open()" [readonly]="true" placeholder="Select date">
                        <mat-datepicker-toggle matIconSuffix [for]="picker1"></mat-datepicker-toggle>
                        <mat-datepicker #picker1></mat-datepicker>
                    </mat-form-field>
                    <mat-error *ngIf="coveredAddressForm.controls['movedDate'].touched && coveredAddressForm.controls['movedDate'].hasError('required')">
                      This is required field.
                    </mat-error>
                    </span>
                  </div>
              </div>
              </form>
            </mat-tab>
          </mat-tab-group>

          <div class="actions" fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="8px">
            <button mat-button type="button" class="sub-button" (click)="transferAgreement()" [disabled]="selectedTab === 'Update Agreement Holder' && userFormStep === 1" *ngIf="!isLoading"><span>Transfer</span></button>
            <img [src]="assetsUrl + 'loder.gif'" alt="loaderImg" width="150" height="30" class="loadimg" *ngIf="isLoading" />
            <button mat-button type="button" class="can-button" (click)="close()" *ngIf="!isLoading"><span>Cancel</span></button>
          </div>
    </div>
</div>
